export async function preprocessLegalPdf(formData: FormData) {
  const res = await fetch(`https://api.customllm.scale.com/private/v1/legal/pdf_document`, {
    method: 'POST',
    body: formData,
  });

  const responseText = await res.text();
  // eslint-disable-next-line
  console.log('responseText: ', responseText.replace(/^"|"$/g, ''));
  return responseText.replace(/^"|"$/g, '');
}

export async function generateResponseLegalPdf(prompt: string, knowledgeBaseId: string) {
  const res = await fetch(
    `https://api.customllm.scale.com/private/v1/legal/${knowledgeBaseId}/analysis`,
    {
      method: 'POST',
      body: JSON.stringify({ prompt }),
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  const responseText = await res.text();
  // eslint-disable-next-line
  console.log('responseText: ', responseText.replace(/^"|"$/g, ''));
  return responseText.replace(/^"|"$/g, '');
}
